import React, { useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { Radio, Tooltip, Typography } from "@mui/material";
import MDDatePicker from "components/MDDatepicker";
import MDSelectBox from "components/MDSelectBox";
import SingleCheckbox from "components/MDCheckBox/MDSingleCheckBox";
import { useFormik } from "formik";
import { initialValues } from "./Schemas/initialValue";
import { validationSchema } from "./Schemas/validation";
import { ModalContext } from "context/ModalContext";
import moment from "moment";
import { addMember, updateMember } from "Apis/member";
import PropTypes from "prop-types";
import { LoginFormContext } from "context/LoginFormContext";
import ImageUploader from "components/MDImageUploader";
import { CommonContext } from "context/CommonContext";
import { useNavigate } from "react-router-dom";
import { MemberContext } from "context/MemberContext";
import MDTextField from "components/MDTextField";
import MDTelInput from "components/MDTelInput";
import SubmitButton from "components/SubmitButton";
import { statusData } from "helpers/constant";
import FormTooltip from "components/MDToolTip";
import dayjs from "dayjs";

const AddMemberForm = ({ memberListing, nativeDistricts, nativeTalukas }) => {
  const { setNotification, memberEditData, profileImage, setProfileImage } =
    useContext(LoginFormContext);
  const { setOpen, formIsEdit } = useContext(ModalContext);
  const {
    parentMemberList,
    districtsList,
    talukasList,
    villagesList,
    districtListing,
    talukaListing,
    villageListing,
    educationListing,
    occupationListing,
    educationsList,
    occupationsList,
    parentDataListing,
    currentSelectedMember,
    setCurrentSelectedMember,
    settingList,
    settingListing,
    relationData,
    bloodGroupData,
    maritalStatusData,
    jsonListing,
    setGeneralOccupationsList,
    generalOccupationsList,
    nativeTalukasList,
    setNativeTalukasList,
    nativeTalukaListing,
    nativeVillagesList,
    setNativeVillagesList,
    nativeVillageListing,
  } = useContext(MemberContext);
  const { districts, talukas, villages } = useContext(CommonContext);
  const [value, setValue] = useState("");
  const navigate = useNavigate();

  const [maritalStatus, setMaritalStatus] = useState({
    marital_status: null,
    blood_group: null,
    education_id: null,
    current_district: null,
    current_taluka: null,
    current_village: null,
    native_district: null,
    native_taluka: null,
    native_village: null,
    relation: null,
  });

  const [status, setStatus] = useState({
    label: "Inactive",
    value: "0",
  });
  const [district, setDistrict] = useState(null);
  const [nativeDistrict, setNativeDistrict] = useState(null);
  const [education, setEducation] = useState(null);
  const [occupation, setOccupation] = useState(null);
  const [taluka, setTaluka] = useState([]);
  const [nativeTaluka, setNativeTaluka] = useState([]);
  const [village, setVillage] = useState([]);
  const [nativeVillage, setNativeVillage] = useState([]);
  const [parentMember, setParentMember] = useState(null);
  const [showMainNum, setShowMainNum] = useState(0);
  const [showIsHead, setShowIsHead] = useState(0);
  const [isVerified, setIsVerified] = useState(0);
  const [generalOccupation, setGeneralOccupation] = useState(null);
  const [mobileNumber, setMobileNumber] = useState("+91");

  //Select Box HandleChange
  const handleAutocompleteChange = (value, name) => {
    const str_value = value ? value?.label : "";
    formik.setFieldValue(name, str_value);
    setMaritalStatus((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDistrictChange = async (value) => {
    let str_value = value?.value;
    if (value) {
      formik.setFieldValue("current_district_id", str_value);
      setDistrict(value);
      setTaluka(null);
      setVillage(null);
      formik.setFieldValue("current_taluka_id", null);
      formik.setFieldValue("current_village_id", null);
      formik.setFieldValue("other_village_name", "");
      await talukaListing({
        filters: { district_id: str_value },
      });
    } else {
      formik.setFieldValue("current_district_id", null);
      formik.setFieldValue("current_taluka_id", null);
      formik.setFieldValue("current_village_id", null);
      formik.setFieldValue("other_village_name", "");
      setDistrict(null);
      setTaluka(null);
      setVillage(null);
      talukaListing();
      villageListing();
    }
  };

  const handleNativeDistrictChange = async (value) => {
    let str_value = value?.label;
    if (value) {
      formik.setFieldValue("native_district", str_value);
      formik.setFieldValue("native_taluka", null);
      formik.setFieldValue("native_village", null);
      formik.setFieldValue("other_native_village_name", "");
      setNativeDistrict(value);
      setNativeTaluka(null);
      setNativeVillage(null);
      await nativeTalukaListing({
        filters: { district_id: value?.value },
      });
    } else {
      formik.setFieldValue("native_district", "");
      formik.setFieldValue("native_taluka", null);
      formik.setFieldValue("native_village", null);
      formik.setFieldValue("other_native_village_name", "");
      setNativeDistrict(null);
      setNativeTaluka(null);
      setNativeVillage(null);
      nativeTalukaListing();
      nativeVillageListing();
    }
  };

  const handleParentMember = async (data) => {
    formik.setFieldValue("parent_id", data?.value);
    setParentMember(data?.label);
  };

  const getParentLabel = (id) => {
    const memberLabel = parentMemberList.find((item) => item.value === id);
    return memberLabel ? memberLabel.label : "-";
  };

  const handleTalukaChange = async (value) => {
    let str_value = value?.value;
    if (value) {
      formik.setFieldValue("current_taluka_id", str_value);
      formik.setFieldValue("current_village_id", null);
      formik.setFieldValue("other_village_name", "");
      setTaluka(value);
      setVillage(null);
      await villageListing({
        filters: { taluka_id: str_value },
      });
    } else {
      formik.setFieldValue("current_taluka_id", null);
      formik.setFieldValue("current_village_id", null);
      formik.setFieldValue("other_village_name", "");
      setTaluka(null);
      setVillage(null);
      villageListing();
    }
  };

  const handleNativeTalukaChange = async (value) => {
    let str_value = value?.label;
    if (value) {
      formik.setFieldValue("native_taluka", str_value);
      formik.setFieldValue("native_village", null);
      formik.setFieldValue("other_native_village_name", "");
      setNativeTaluka(value);
      setNativeVillage(null);
      await nativeVillageListing({
        filters: { taluka_id: value?.value },
      });
    } else {
      formik.setFieldValue("native_taluka", "");
      formik.setFieldValue("native_village", null);
      formik.setFieldValue("other_native_village_name", "");
      setNativeTaluka(null);
      setNativeVillage(null);
      nativeVillageListing();
    }
  };

  const handleVillageChange = async (value) => {
    let str_value = value?.value;
    if (value) {
      formik.setFieldValue("current_village_id", str_value);
      formik.setFieldValue("other_village_name", "");
      setVillage(value);
    } else {
      formik.setFieldValue("current_village_id", null);
      formik.setFieldValue("other_village_name", "");
      setVillage(null);
    }
  };

  const handleNativeVillageChange = async (value) => {
    let str_value = value?.label;
    if (value) {
      formik.setFieldValue("native_village", str_value);
      formik.setFieldValue("other_native_village_name", "");
      setNativeVillage(value);
    } else {
      formik.setFieldValue("native_village", "");
      formik.setFieldValue("other_native_village_name", "");
      setNativeVillage(null);
    }
  };

  const getStatusLabel = (id) => {
    const status = statusData.find((item) => item.value == id);
    return status ? status.label : "-";
  };

  const getDistrictLabel = (id) => {
    const district = districts.find((item) => item.value === id);
    return district ? district.label : "-";
  };

  const getTalukaLabel = (id) => {
    const taluka = talukas.find((item) => item.value === id);
    return taluka ? taluka.label : "-";
  };

  const getVillageLabel = (id) => {
    const village = villages.find((item) => item.value === id);
    return village ? village.label : "-";
  };

  const getEducationLabel = (id) => {
    const education = educationsList.find((item) => item.value === id);
    return education ? education.label : "-";
  };

  const getOccupationLabel = (id) => {
    const occupation = occupationsList.find((item) => item.value === id);
    return occupation ? occupation.label : "-";
  };

  const getGeneralOccupationLabel = (id) => {
    const occupation = generalOccupationsList.find((item) => item.value === id);
    return occupation ? occupation.label : "-";
  };

  const handleRadioChange = (event) => {
    setValue(event.target.value);
  };

  //HandleDateChange
  const handleDate = (date, fieldName) => {
    if (date) {
      let dateFormat = moment(new Date(date)).format("YYYY-MM-DD");
      formik.setFieldValue("birth_date", dateFormat);
    } else {
      formik.setFieldValue(fieldName, null);
    }
  };

  const handleExpiryDate = (date, fieldName) => {
    if (date) {
      let dateFormat = moment(new Date(date)).format("YYYY-MM-DD");
      formik.setFieldValue("expire_verification", dateFormat);
    } else {
      formik.setFieldValue(fieldName, null);
    }
  };

  //setData in Formik...
  const setDataInFormik = async () => {
    formik.setValues(memberEditData);
    formik.setFieldValue("other_village_name", memberEditData?.other_village_name);
    formik.setFieldValue("other_native_village_name", memberEditData?.other_native_village_name);
    formik.setFieldValue("image", memberEditData?.member_images[0]?.image.split("/").pop());
    formik.setFieldValue("show_main_number", memberEditData?.show_main_number);
    formik.setFieldValue("is_head_person", memberEditData?.is_head_person);
    formik.setFieldValue("member_relation_id", memberEditData?.member_relation_id);
    formik.setFieldValue("country_code", memberEditData?.country_code);
    formik.setFieldValue("mobile_number", memberEditData?.mobile_number);
    formik.setFieldValue(
      "member_number",
      memberEditData?.is_head_person === 1 ? memberEditData?.member_number : null
    );
    if (
      memberEditData?.marital_status ||
      memberEditData?.blood_group ||
      memberEditData?.education_id ||
      memberEditData?.current_district ||
      memberEditData?.current_taluka ||
      memberEditData?.native_district ||
      memberEditData?.current_district_id ||
      memberEditData?.current_taluka_id ||
      memberEditData?.current_village_id ||
      memberEditData?.native_taluka ||
      memberEditData?.native_village ||
      memberEditData?.relation ||
      memberEditData?.first_name ||
      memberEditData?.middle_name ||
      memberEditData?.aadhar_no ||
      memberEditData?.surname ||
      memberEditData?.maternal_surname ||
      memberEditData?.birth_date
    ) {
      setMaritalStatus((prev) => ({
        ...prev,
        marital_status: memberEditData?.marital_status
          ? { label: memberEditData?.marital_status }
          : null,
        blood_group: memberEditData?.blood_group ? { label: memberEditData?.blood_group } : null,
        education_id: memberEditData?.education_id,
        current_district: memberEditData?.current_district,
        current_taluka: memberEditData?.current_taluka,
        native_district: memberEditData?.native_district,
        native_taluka: memberEditData?.native_taluka,
        native_village: memberEditData?.native_village,
        relation: memberEditData?.relation ? { label: memberEditData?.relation } : null,
      }));
      setProfileImage({
        url: memberEditData?.member_images[0]?.image || null,
        name: null,
      });
      setShowIsHead(memberEditData?.is_head_person === 1);
      setIsVerified(memberEditData?.is_verified);
      setShowMainNum(memberEditData?.show_main_number === 1);
      setMobileNumber(
        "+" + memberEditData?.country_code + memberEditData?.mobile_number.toString()
      );
    }
  };

  useEffect(() => {
    if (!formIsEdit && currentSelectedMember) {
      formik.setFieldValue("parent_id", currentSelectedMember);
      setParentMember(
        currentSelectedMember
          ? {
              label: getParentLabel(currentSelectedMember),
              value: currentSelectedMember,
            }
          : null
      );
    }
    return () => {
      setCurrentSelectedMember(undefined);
      setParentMember(null);
      setShowIsHead(0);
    };
  }, []);

  useEffect(() => {
    const durationSetting = settingList.find((item) => item.label === "member_expire_duration");
    if (durationSetting?.value) {
      const monthsToAdd = parseInt(durationSetting.value, 10);
      if (!isNaN(monthsToAdd)) {
        const newDate = dayjs().add(monthsToAdd, "month").toDate();
        let newDateFormat = moment(new Date(newDate)).format("YYYY-MM-DD");
        formik.setFieldValue("expire_verification", newDateFormat);
      }
    }
    settingListing();
  }, []);

  useEffect(() => {
    jsonListing();
    districtListing();
    talukaListing({
      filters: { district_id: memberEditData?.current_district_id },
    });
    const nativeDistrict = nativeDistricts.find(
      (district) => district.label === memberEditData?.native_district
    );
    nativeTalukaListing({
      filters: { district_id: nativeDistrict?.value },
    });
    villageListing({
      filters: { taluka_id: memberEditData?.current_taluka_id },
    });
    const nativeVillage = nativeTalukas.find(
      (district) => district.label === memberEditData?.native_taluka
    );
    nativeVillageListing({
      filters: { taluka_id: nativeVillage?.value },
    });
    if (formIsEdit) {
      setDataInFormik();
      setStatus({
        label: getStatusLabel(memberEditData?.is_active),
        value: memberEditData?.is_active,
      });
      setDistrict(
        memberEditData?.current_district_id
          ? {
              label: getDistrictLabel(memberEditData?.current_district_id),
              value: memberEditData?.current_district_id,
            }
          : null
      );
      setNativeDistrict(
        memberEditData?.native_district
          ? {
              label: memberEditData?.native_district,
              value: memberEditData?.native_district,
            }
          : null
      );
      setTaluka(
        memberEditData?.current_taluka_id
          ? {
              label: getTalukaLabel(memberEditData?.current_taluka_id),
              value: memberEditData?.current_taluka_id,
            }
          : null
      );
      setNativeTaluka(
        memberEditData?.native_taluka
          ? {
              label: memberEditData?.native_taluka,
              value: memberEditData?.native_taluka,
            }
          : null
      );
      if (memberEditData?.other_village_name) {
        formik.setFieldValue("current_village_id", "other");
        setVillage({
          label: "Other",
          value: "other",
        });
      } else if (memberEditData?.current_village_id) {
        setVillage({
          label: getVillageLabel(memberEditData?.current_village_id),
          value: memberEditData?.current_village_id,
        });
      } else {
        setVillage(null);
      }

      setNativeVillage(
        memberEditData?.native_village
          ? {
              label: memberEditData?.native_village,
              value: memberEditData?.native_village,
            }
          : null
      );
      setParentMember(
        memberEditData?.parent_id
          ? {
              label: getParentLabel(memberEditData?.parent_id),
              value: memberEditData?.parent_id,
            }
          : null
      );
      setEducation(
        memberEditData?.education_id
          ? {
              label: getEducationLabel(memberEditData?.education_id),
              value: memberEditData?.education_id,
            }
          : null
      );
      setGeneralOccupation(
        memberEditData?.general_occupation_id
          ? {
              label: getGeneralOccupationLabel(memberEditData?.general_occupation_id),
              value: memberEditData?.general_occupation_id,
            }
          : null
      );
    } else if (formIsEdit === false) {
      educationListing();
      occupationListing();
      parentDataListing();
      setProfileImage({
        url: null,
        name: null,
      });
    }
    if (formIsEdit === false && currentSelectedMember === undefined) {
      setShowIsHead(1);
      formik.setFieldValue("is_head_person", 1);
    }
  }, []);

  //HandleSubmit Form
  const handleSubmit = async (values) => {
    if (values.aadhar_no == "" || !values.aadhar_no) {
      values.aadhar_no = null;
    }
    values.other_village_name =
      values.current_village_id == "other" ? values.other_village_name : "";
    values.current_village_id =
      values.current_village_id == "other" ? null : values.current_village_id;
    values.other_native_village_name =
      values.native_village == "Other" ? values.other_native_village_name : "";
    if (!formIsEdit) {
      let response = await addMember(values);
      if (response?.status === 200) {
        memberListing();
        setOpen(false);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response.data.message,
          open: true,
        });
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: response.data.message,
          open: true,
        });
      }
    } else {
      let editData = await updateMember(values);
      if (editData?.status === 200) {
        setOpen(false);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: editData.data.message,
          open: true,
        });
        memberListing();
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: editData.data.message,
          open: true,
        });
      }
    }
  };

  const handleStatusChange = (value) => {
    if (value) {
      formik.setFieldValue("is_active", value.value);
      setStatus(value);
    } else {
      formik.setFieldValue("is_active", null);
      setStatus(null);
    }
  };

  //Formik
  const formik = useFormik({
    initialValues: initialValues,
    // validationSchema: validationSchema,
    validationSchema: validationSchema(showIsHead),
    onSubmit: handleSubmit,
  });

  const handleMainNumber = (e) => {
    setShowMainNum(e?.target?.checked);
    formik.setFieldValue("show_main_number", e?.target?.checked ? 1 : 0);
  };

  const handleIsHeadPerson = (e) => {
    setShowIsHead(e?.target?.checked);
    formik.setFieldValue("is_head_person", e?.target?.checked ? 1 : 0);
    formik.setFieldValue("relation", null);
    formik.setFieldValue("parent_id", null);
    formik.setFieldValue("show_main_number", 1);
    setMaritalStatus((prev) => ({
      ...prev,
      relation: "",
    }));
  };

  const handleIsVerified = (e) => {
    setIsVerified(e?.target?.checked);
    formik.setFieldValue("is_verified", e?.target?.checked ? 1 : 0);
  };

  const handleEducationChange = (value) => {
    let str_value = value?.value;
    if (value) {
      formik.setFieldValue("education_id", str_value);
      setEducation(value);
    } else {
      formik.setFieldValue("education_id", null);
      setEducation(null);
    }
  };

  const handleGeneralOccupationChange = (value) => {
    let str_value = value?.value;
    if (value) {
      formik.setFieldValue("general_occupation_id", str_value);
      setGeneralOccupation(value);
    } else {
      formik.setFieldValue("general_occupation_id", null);
      setGeneralOccupation(null);
    }
  };

  const handlePhoneValueChange = (newPhone) => {
    setMobileNumber(newPhone?.numberValue);
    formik.setFieldValue("country_code", newPhone?.countryCallingCode);
    formik.setFieldValue("mobile_number", newPhone?.nationalNumber);
  };

  return (
    <>
      <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
        {/* Image */}
        <MDBox sx={{ fontSize: "16px", fontWeight: "400", marginBottom: "5px", marginTop: "10px" }}>
          Profile Image
        </MDBox>
        <MDBox mb={2} className="metromonial_image">
          <MDBox className="metromonial_message">
            <ImageUploader
              img={profileImage?.url}
              folderName={"/members"}
              name={"image"}
              fileName={"image"}
              formik={formik}
              label="Profile Image"
              hideLabel={true}
              required
            />
          </MDBox>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ "@media (max-width: 768px)": { paddingTop: "5px !important" } }}
          >
            <MDBox
              sx={{
                fontSize: "14px",
                width: "100%",
                paddingLeft: "20px",
                paddingTop: "15px",
                "@media (max-width: 768px)": {
                  display: "block",
                  paddingLeft: "0px",
                },
              }}
            >
              Image can't be larger than 5 MB
              <span
                style={{
                  marginTop: "2px",
                  display: "block",
                }}
              >
                (છબીનું કદ 5 mb કરતાં ઓછું હોવું જરૂરી છે)
              </span>
            </MDBox>
          </Grid>
        </MDBox>
        <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
          <SingleCheckbox
            xs={12}
            sm={12}
            md={12}
            name="is_head_person"
            label={
              <>
                This person is the head of the family
                <br />
                <span style={{ marginTop: "8px", display: "block" }}>
                  (આ વ્યક્તિ પરિવારના મુખ્ય મેમ્બર છે)
                </span>
              </>
            }
            onChange={(event) => handleIsHeadPerson(event)}
            onBlur={formik.handleBlur}
            checked={showIsHead}
            disabled={Boolean(
              (formIsEdit && memberEditData?.is_head_person === 1) || currentSelectedMember
            )}
          />
        </Grid>
        {!showIsHead && (
          <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid item xs={12} md={6} sx={{ paddingTop: "10px !important" }}>
              <MDSelectBox
                name="parent_id"
                defaultValue={parentMember}
                options={parentMemberList}
                handleChange={(value) => handleParentMember(value)}
                label="Select Head Member (મુખ્ય સભ્ય પસંદ કરો)"
                width="100%"
                isImage={true}
                multiple={false}
                onBlur={formik.handleBlur}
                required
              />
              {formik.touched.parent_id && formik.errors.parent_id && (
                <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                  {formik.errors.parent_id}
                </MDBox>
              )}
            </Grid>

            <Grid item xs={12} md={6} sx={{ paddingTop: "10px !important" }}>
              <MDSelectBox
                name="relation"
                defaultValue={maritalStatus.relation}
                options={relationData}
                handleChange={(val) => handleAutocompleteChange(val, "relation")}
                label="Relationship With Head Of Family (પરિવારના મુખ્ય મેમ્બર સાથે નો સંબંધ)"
                width="100%"
                multiple={false}
                onBlur={formik.handleBlur}
                required
              />
              {formik.touched.relation && formik.errors.relation && (
                <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                  {formik.errors.relation}
                </MDBox>
              )}
            </Grid>
          </Grid>
        )}

        <MDBox component="h2" sx={{ fontSize: "22px", fontWeight: "600", marginTop: "30px" }}>
          Member Information
        </MDBox>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDInput
              type="text"
              name="member_number"
              value={formik.values.member_number}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Member Number"
              sx={{ width: "100%" }}
              variant="standard"
              required={showIsHead}
            />
            {formik.touched.member_number && formik.errors.member_number && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.member_number}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDInput
              type="text"
              name="first_name"
              value={formik.values.first_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="First Name (તમારું નામ)"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.first_name && formik.errors.first_name && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.first_name}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDInput
              type="text"
              name="middle_name"
              value={formik.values.middle_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              sx={{ width: "100%" }}
              label="Middle Name (પિતા નું અથવા પતિ નું નામ)"
              variant="standard"
              required
            />
            {formik.touched.middle_name && formik.errors.middle_name && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.middle_name}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDInput
              type="text"
              name="surname"
              value={formik.values.surname}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Surname (અટક)"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.surname && formik.errors.surname && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.surname}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDInput
              type="text"
              name="maternal_surname"
              value={formik.values.maternal_surname}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Maternal Surname (મોસાળ ની અટક)"
              sx={{ width: "100%" }}
              variant="standard"
            />
            {formik.touched.maternal_surname && formik.errors.maternal_surname && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.maternal_surname}
              </MDBox>
            )}
          </Grid>

          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDInput
              type="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Email"
              sx={{ width: "100%" }}
              variant="standard"
            />
          </Grid>

          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDTelInput
              name="mobile_number"
              value={mobileNumber}
              handleChange={(event) => handlePhoneValueChange(event)}
              onBlur={formik.handleBlur}
              label="Mobile No"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.mobile_number && formik.errors.mobile_number && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.mobile_number}
              </MDBox>
            )}
          </Grid>
          {!showIsHead && (
            <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
              <SingleCheckbox
                xs={12}
                sm={12}
                md={12}
                name="show_main_number"
                label={
                  <>
                    This number will be visible to all members
                    <br />
                    <span style={{ marginTop: "8px", display: "block" }}>
                      (આ નંબર બધા સભ્યોને દેખાશે)
                    </span>
                  </>
                }
                onChange={(event) => handleMainNumber(event)}
                onBlur={formik.handleBlur}
                checked={showMainNum}
              />
            </Grid>
          )}

          <Grid item xs={12} md={6}>
            <MDBox sx={{ fontSize: "16px", fontWeight: "400", marginBottom: "5px" }}>
              Gender (જાતિ)
            </MDBox>
            <FormControl>
              <RadioGroup
                row
                sx={{ gap: "20px" }}
                name="gender"
                value={formik.values.gender}
                onBlur={formik.handleBlur}
                onChange={(event) => formik.setFieldValue("gender", event.target.value)}
              >
                <FormControlLabel value="Male" control={<Radio />} label="Male" />
                <FormControlLabel value="Female" control={<Radio />} label="Female" />
              </RadioGroup>
              {formik.touched.gender && formik.errors.gender && (
                <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                  {formik.errors.gender}
                </MDBox>
              )}
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ paddingTop: showIsHead ? "20px !important" : "10px !important" }}
          >
            <MDSelectBox
              name="marital_status"
              defaultValue={maritalStatus?.marital_status}
              options={maritalStatusData}
              handleChange={(value) => handleAutocompleteChange(value, "marital_status")}
              label="Marital Status"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
            />
            {formik.touched.marital_status && formik.errors.marital_status && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.marital_status}
              </MDBox>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{ paddingTop: showIsHead ? "30px !important" : "40px !important" }}
          >
            <MDBox className="date__picker">
              <MDDatePicker
                width="100% !important"
                name="birth_date"
                value={formik.values.birth_date}
                onChange={(date) => handleDate(date, "birth_date")}
                onBlur={formik.handleBlur}
                label="Birth Date (જન્મ તારીખ)"
                disableFuture={true}
                required
              />
              {formik.touched.birth_date && formik.errors.birth_date && (
                <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                  {formik.errors.birth_date}
                </MDBox>
              )}
            </MDBox>
          </Grid>
          <Grid
            item
            xs={12}
            md={showIsHead ? 12 : 6}
            sx={{ paddingTop: showIsHead ? "20px !important" : "30px !important" }}
          >
            <MDSelectBox
              name="blood_group"
              defaultValue={maritalStatus?.blood_group}
              options={bloodGroupData}
              handleChange={(value) => handleAutocompleteChange(value, "blood_group")}
              label="Blood Group"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
            />
            {formik.touched.blood_group && formik.errors.blood_group && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.blood_group}
              </MDBox>
            )}
          </Grid>

          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDInput
              type="number"
              name="aadhar_no"
              value={formik.values.aadhar_no}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              sx={{ width: "100%" }}
              label="Aadhaar Number (આધાર નંબર)"
              variant="standard"
              required={showIsHead ? true : false}
            />
            {formik.touched.aadhar_no && formik.errors.aadhar_no && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.aadhar_no}
              </MDBox>
            )}
          </Grid>
        </Grid>

        <MDBox component="h2" sx={{ fontSize: "22px", fontWeight: "600", marginTop: "30px" }}>
          Professional Information
        </MDBox>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={12} sx={{ paddingTop: "20px !important" }}>
            <MDSelectBox
              name="education_id"
              defaultValue={education}
              options={educationsList}
              handleChange={(value) => handleEducationChange(value)}
              label="Education"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
            />
            {formik.touched.education_id && formik.errors.education_id && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.education_id}
              </MDBox>
            )}
          </Grid>
        </Grid>
        <MDBox component="h2" sx={{ fontSize: "22px", fontWeight: "600", marginTop: "30px" }}>
          Occupation
        </MDBox>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDSelectBox
              name="general_occupation_id"
              defaultValue={generalOccupation}
              options={generalOccupationsList}
              handleChange={(value) => handleGeneralOccupationChange(value)}
              label="General Occupation"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
            />
            {formik.touched.general_occupation_id && formik.errors.general_occupation_id && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.general_occupation_id}
              </MDBox>
            )}
          </Grid>
          {/* <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDSelectBox
              name="occupation_id"
              defaultValue={occupation}
              options={occupationsList}
              handleChange={(value) => handleOccupationChange(value)}
              label="Optional Occupation"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
            />
          </Grid> */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDInput
              type="text"
              name="occupation_details"
              value={formik.values.occupation_details}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Occupation Text"
              sx={{ width: "100%" }}
              variant="standard"
            />
          </Grid>
        </Grid>
        <Grid item xs={12} md={12} sx={{ paddingTop: "20px !important" }}>
          <MDInput
            type="text"
            name="company_name"
            value={formik.values.company_name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            label="Company Name"
            sx={{ width: "100%" }}
            variant="standard"
          />
        </Grid>
        <MDBox component="h2" sx={{ fontSize: "22px", fontWeight: "600", marginTop: "30px" }}>
          Address Details
        </MDBox>
        <Grid item xs={12} md={12} sx={{ paddingTop: "20px !important" }}>
          <MDTextField
            name="current_address"
            value={formik.values.current_address}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="address_textarea"
            variant="standard"
            fullWidth
            multiline={true}
            rows={4}
            label="Current Address"
          />
          {formik.touched.current_address && formik.errors.current_address && (
            <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
              {formik.errors.current_address}
            </MDBox>
          )}
        </Grid>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDSelectBox
              name="current_district_id"
              defaultValue={district}
              options={districtsList}
              handleChange={(value) => handleDistrictChange(value)}
              label="Current District"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
            />
            {formik.touched.current_district_id && formik.errors.current_district_id && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.current_district_id}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDSelectBox
              name="current_taluka_id"
              defaultValue={taluka}
              options={talukasList}
              handleChange={(value) => handleTalukaChange(value)}
              label="Current Taluka"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
              disabled={!district ? true : false}
            />
            {formik.touched.current_taluka_id && formik.errors.current_taluka_id && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.current_taluka_id}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDSelectBox
              name="current_village_id"
              defaultValue={village}
              options={villagesList}
              handleChange={(value) => handleVillageChange(value)}
              label="Current Village"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
              disabled={!taluka || !district ? true : false}
            />
            {formik.touched.current_village_id && formik.errors.current_village_id && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.current_village_id}
              </MDBox>
            )}
          </Grid>
          {formik.values.current_village_id == "other" && formik.values.current_taluka_id && (
            <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
              <MDInput
                type="text"
                name="other_village_name"
                value={formik.values.other_village_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Other Village Name"
                sx={{ width: "100%" }}
                variant="standard"
              />
              {formik.touched.other_village_name && formik.errors.other_village_name && (
                <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                  {formik.errors.other_village_name}
                </MDBox>
              )}
            </Grid>
          )}
        </Grid>

        <Grid item xs={12} md={12} sx={{ paddingTop: "20px !important" }}>
          <MDTextField
            name="native_address"
            value={formik.values.native_address}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="address_textarea"
            label="Native address (મૂળ સરનામું)"
            fullWidth
            multiline={true}
            rows={4}
            variant="standard"
          />
        </Grid>
        <Grid
          container
          spacing={2}
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          sx={{ paddingTop: "20px !important" }}
        >
          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDSelectBox
              name="native_district"
              defaultValue={nativeDistrict}
              options={districtsList}
              handleChange={(value) => handleNativeDistrictChange(value)}
              label="Native District"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
            />
          </Grid>

          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDSelectBox
              name="native_taluka"
              defaultValue={nativeTaluka}
              options={nativeTalukasList}
              handleChange={(value) => handleNativeTalukaChange(value)}
              label="Native Taluka"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
              disabled={!nativeDistrict ? true : false}
            />
          </Grid>

          <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
            <MDSelectBox
              name="native_village"
              defaultValue={nativeVillage}
              options={nativeVillagesList}
              handleChange={(value) => handleNativeVillageChange(value)}
              label="Native Village"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
              disabled={!nativeTaluka || !nativeDistrict ? true : false}
            />
          </Grid>

          {formik.values.native_village == "Other" && formik.values.native_taluka && (
            <Grid item xs={12} md={6} sx={{ paddingTop: "20px !important" }}>
              <MDInput
                type="text"
                name="other_native_village_name"
                value={formik.values.other_native_village_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Other Village Name"
                sx={{ width: "100%" }}
                variant="standard"
              />
              {formik.touched.other_native_village_name &&
                formik.errors.other_native_village_name && (
                  <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                    {formik.errors.other_native_village_name}
                  </MDBox>
                )}
            </Grid>
          )}
          <Grid
            item
            xs={12}
            md={6}
            sx={{ paddingTop: showIsHead ? "30px !important" : "40px !important" }}
          >
            <MDBox className="date__picker">
              <MDDatePicker
                width="100% !important"
                name="expire_verification"
                value={formik.values.expire_verification}
                onChange={(date) => handleExpiryDate(date, "expire_verification")}
                onBlur={formik.handleBlur}
                label="Expire Verification Date"
                disablePast={true}
              />
              {formik.touched.expire_verification && formik.errors.expire_verification && (
                <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                  {formik.errors.expire_verification}
                </MDBox>
              )}
            </MDBox>
          </Grid>

          <Grid item xs={12} md={6} sx={{ paddingTop: "40px !important" }}>
            <SingleCheckbox
              xs={12}
              sm={12}
              md={12}
              name="is_verified"
              label={
                <>
                  This member is verified
                  <br />
                  <span style={{ marginTop: "8px", display: "block" }}>
                    (આ સભ્ય વેરીફાઈ થયેલ છે)
                  </span>
                </>
              }
              onChange={(event) => handleIsVerified(event)}
              onBlur={formik.handleBlur}
              checked={isVerified}
            />
          </Grid>
        </Grid>

        {/* status */}
        <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
          <MDSelectBox
            name="is_active"
            defaultValue={status}
            options={statusData}
            handleChange={(value) => handleStatusChange(value)}
            onBlur={formik.handleBlur}
            width="100%"
            multiple={false}
            label="Status"
            required
          />
          {formik.touched.is_active && formik.errors.is_active && (
            <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
              {formik.errors.is_active}
            </MDBox>
          )}
        </Grid>

        <MDBox sx={{ width: "100%", textAlign: "center", marginTop: "40px" }}>
          <SubmitButton btnText={formIsEdit ? "Update" : "Add"} type="submit" />
        </MDBox>
      </MDBox>
    </>
  );
};
AddMemberForm.propTypes = {
  memberListing: PropTypes.func,
};
export default AddMemberForm;
